// Single source of truth for the Refdocs glyph. The three path strings here
// power the React `Logomark` component and the edge-rendered open-graph
// image; keeping them in one place means a future palette tweak or shape
// change only touches one file.

export const logoColors = {
  blue: "#2e7df0",
  darkPurple: "#2c1d9a",
  purple: "#4b3acf",
} as const;

export const logoPaths = [
  {
    fill: logoColors.blue,
    d: "M587.77,573.19c-4.3,14.38-19.26,35.73-43.35,35.72c-26.2-0.13-39.03-19.39-46.32-36.24c-4.12-9.52-45.88-126.11-45.88-126.11c-4.62-10.13-12.79-17.57-27.05-18.63c-24.11,0.38-155.19,0-155.19,0L318.64,294c5.87-18.06,18.37-32.39,41.58-32.38l272.64,4.13c12.09,0.15,21.83,4.77,29.77,13.02c8.7,9.05,13.11,20.44,11.81,32.99c-0.81,7.78-5.94,22.96-5.94,22.96",
  },
  {
    fill: logoColors.darkPurple,
    d: "M221.88,570.77c-5.87,19.3-22.44,36.94-41.81,38.36l364.35-0.22c-37.47,0-48.91-44.42-48.91-44.42s-22.17-60.39-27.97-75.95c-5.44-14.62-9.51-27.5-15.32-41.98c-4.19-13.15-14.34-18.64-27.05-18.63l-155.19,0",
  },
  {
    fill: logoColors.purple,
    d: "M269.97,427.94l-49.9,148.2c-19.98,44.93-64.45,42.92-83.25,1.68c0,0-16.59-47.2-20.24-57.56c-6-17.04-12.1-34.04-18.1-51.08c-1.83-5.19-5.11-15.7-5.11-15.7c-4.84-25.54,19.54-25.3,19.54-25.3l29.04-0.13L269.97,427.94z",
  },
] as const;
